export default __webpack_public_path__ + "static/media/must-rotate.ca07aaea.svg";